import { useRecoilValue, useSetRecoilState } from "recoil";
import { loginState } from "../../stores/loginState";
import { useMutation } from "react-query";
import { HandexInstance, HanjinInstance, LogenInstance, LotteInstance } from "../instance";
import dayjs from "dayjs";
import { editDataState } from "../../stores/edit/editDataState";

// TODO 업무구분 수정 데이터 조회 API
const useGetEditData = ({ date, workType, carNum}) => {
  // NOTE 상태 변수 선언
  const login = useRecoilValue(loginState);
  const editData = useSetRecoilState(editDataState);

  const filterData = (data) => {
    // 필터링 로직 구현
    return data.filter(item => {
      const matchesWorkType = workType === "전체" || item.tm_dv === workType;
      const matchesBarcode = !carNum || item.car_num.includes(carNum);

      return matchesWorkType && matchesBarcode;
    });
  };

  const mutationOptions = {
    onSuccess: (data) => {
      if (data.result === "00" || data.result === "77") {
        const filteredData = filterData(data.data);
        editData(filteredData);
      }
    },
    onError: (error) => {
      console.log(error);
    },
  };

  const postData = {
    api: "invoiceAll",
    data: [
      {
        start_time: `${dayjs(date).format("YYYY-MM-DD")} 00:00:00`,
        end_time: `${dayjs(date).format("YYYY-MM-DD")} 23:59:59`,
        bran_cd: login.branchCode,
        longTime: "",
        car_num: "",
        company: login.company
      },
    ],
  };

  let mutationFn;

  if (login.company === "LOGEN") {
    mutationFn = () => LogenInstance.post("/lose", postData);
  } else if (login.company === "LOTTE") {
    mutationFn = () => LotteInstance.post("/lose", postData);
  } else if (login.company === "HANJIN") {
    mutationFn = () => HanjinInstance.post("/lose", postData);
  } else if (login.company === "HANDEX") {
    mutationFn = () => HandexInstance.post("/lose", postData);
  } else {
    mutationFn = () => {
      throw new Error("Invalid company");
    };
  }

  return useMutation("getAmount", mutationFn, mutationOptions);
};

export default useGetEditData;
